import React from "react";
import { Laptop, Settings, DollarSign, ArrowRight } from "lucide-react";
import { processSteps } from "../../mock";
import Reveal from "../Reveal";

const icons = [Laptop, Settings, DollarSign];

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#c6a15b]">How It Works</p>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0b1f3a] mt-3">
            3-Step Simplified Process
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            From your first conversation to funds in your account — fast, simple and transparent.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-8 md:grid-cols-3 relative">
          {processSteps.map((s, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={s.num} delay={i * 120}>
                <div className="relative text-center px-6">
                  <div className="mx-auto h-20 w-20 rounded-2xl bg-[#0b1f3a] flex items-center justify-center relative">
                    <Icon className="h-9 w-9 text-[#c6a15b]" />
                    <span className="absolute -top-3 -right-3 h-9 w-9 rounded-full bg-[#c6a15b] text-[#0b1f3a] font-display font-extrabold text-sm flex items-center justify-center ring-4 ring-white">
                      {s.num}
                    </span>
                  </div>
                  <h3 className="font-display font-bold text-xl text-[#0b1f3a] mt-6">
                    Step {i + 1}: {s.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
                {i < processSteps.length - 1 && (
                  <ArrowRight className="hidden md:block absolute top-10 -right-4 h-7 w-7 text-[#c6a15b]/40" />
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
